import {getCookie} from './utils';

export default {
  DEBUG: getCookie('debug'),
  API_HOST: getCookie('api'),
};



// WEBPACK FOOTER //
// ./src/debug.js